<template>
  <app-modal v-model="isDialogOpened"
             size="xs"
             :ok-loading="duplicateEnvelopeTemplatePending"
             :ok-text="$t('project.signing-checklist.envelope-templates.dialogs.DuplicateDialog.duplicate')"
             :cancel-disabled="duplicateEnvelopeTemplatePending"
             @ok="prepareDuplicateEnvelopeTemplate"
             @cancel="closeDialog"
  >
    <template #title>{{ $t('project.signing-checklist.envelope-templates.dialogs.DuplicateDialog.title') }}</template>
    <template #body>
      <AppTextField v-model="v$.copyName.$model"
                    :label="$t('project.signing-checklist.envelope-templates.dialogs.DuplicateDialog.labelName')"
                    :counter="MAX_NAME_LENGTH"
                    maxLength="100"
                    :error-messages="copyNameErrors"
      />
    </template>
  </app-modal>
</template>

<script>

import { useVuelidate } from '@vuelidate/core'
import { maxLength, required } from '@vuelidate/validators'
import { mapActions, mapState } from 'vuex'

import AppTextField from '@/common/AppTextField.vue'
import { formFieldErrors } from '@/common/utils/form'
import { toast } from '@/common/utils/toast'
import { dialogMixin } from '@/mixins/dialogMixin'
const MAX_NAME_LENGTH = 100

export default {
  name: 'DuplicateDialog',
  components: { AppTextField },
  mixins: [dialogMixin],
  setup: () => ({ v$: useVuelidate() }),
  validations: {
    copyName: { required, maxLength: maxLength(MAX_NAME_LENGTH) },
  },
  props: {
    envelopeTemplate: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      MAX_NAME_LENGTH,
      copyName: this.envelopeTemplate.title,
    }
  },
  computed: {
    ...mapState('envelopeTemplates', ['duplicateEnvelopeTemplatePending']),
    copyNameErrors () {
      return formFieldErrors(
          this.v$.copyName,
          [
            ['required', this.$t('common.validations.fieldRequired', { fieldName: this.$t('project.signing-checklist.envelope-templates.dialogs.DuplicateDialog.labelName') })],
            ['maxLength', this.$t('common.validations.maxLength', { fieldName: this.$t('project.signing-checklist.envelope-templates.dialogs.DuplicateDialog.labelName'), maxLength: MAX_NAME_LENGTH })],
          ],
      )
    },
  },
  methods: {
    ...mapActions('envelopeTemplates', ['DUPLICATE_ENVELOPE_TEMPLATE']),
    async prepareDuplicateEnvelopeTemplate () {
      this.v$.$touch()

      if (!this.v$.$invalid) {
        try {
          await this.DUPLICATE_ENVELOPE_TEMPLATE({
            envelopeTemplateId: this.envelopeTemplate.id,
            data: {
              title: this.copyName,
            },
          })

          this.closeDialog()
        } catch (error) {
          toast.error(this.$t('project.signing-checklist.envelope-templates.dialogs.DuplicateDialog.duplicateEnvelopeTemplateError'))
        }
      }
    },
  },
}
</script>
